/**
 * Apply export-quote bulk color / glazing changes across all drawings.
 * Individual drawings can still be edited afterward to override.
 */

export function applyBulkExteriorColor(config = {}, colorId) {
  if (!colorId) return config;
  return {
    ...config,
    color: colorId,
    exteriorColor: colorId,
  };
}

export function applyBulkInteriorColor(config = {}, colorId) {
  if (!colorId) return config;
  return {
    ...config,
    interiorFrameColor: colorId,
    interiorColor: colorId,
  };
}

export function applyBulkGlazing(config = {}, glazingId) {
  if (!glazingId) return config;
  const next = {
    ...config,
    glazingType: glazingId,
  };
  if (config.rightGlazingType) {
    next.rightGlazingType = glazingId;
  }
  return next;
}

export function mapDrawingConfig(drawing, configMapper) {
  if (!drawing || typeof configMapper !== 'function') return drawing;
  const config = drawing.config || {};
  return {
    ...drawing,
    config: configMapper(config),
  };
}

/** Shared exterior id if every drawing matches; otherwise null (mixed). */
export function getCommonExteriorColorId(drawings = []) {
  const ids = drawings
    .map((d) => d?.config?.exteriorColor || d?.config?.color)
    .filter(Boolean);
  if (!ids.length) return null;
  const first = ids[0];
  return ids.every((id) => id === first) ? first : null;
}

export function getCommonInteriorColorId(drawings = []) {
  const ids = drawings
    .map((d) => d?.config?.interiorFrameColor || d?.config?.interiorColor)
    .filter(Boolean);
  if (!ids.length) return null;
  const first = ids[0];
  return ids.every((id) => id === first) ? first : null;
}

export function getCommonGlazingId(drawings = []) {
  const ids = drawings.map((d) => d?.config?.glazingType).filter(Boolean);
  if (!ids.length) return null;
  const first = ids[0];
  return ids.every((id) => id === first) ? first : null;
}
